import styled from 'styled-components';

import { lighten } from 'utils/colours';

import { Select as AntdSelect } from 'antd';

/**
 * This does not support colours of the dropdown content, which in a separate div in the browser (not a child)
 */
const Select = styled(AntdSelect)`
    &.ant-select-focused.ant-select-multiple .ant-select-selector {
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
        box-shadow: ${({ theme }) => `0 0 0 2px ${lighten(theme.colour.primary, 40)}`};
    }

    &.ant-select-focused.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
        box-shadow: ${({ theme }) => `0 0 0 2px ${lighten(theme.colour.primary, 40)}`};
    }

    &.ant-select:not(.ant-select-disabled):hover .ant-select-selector {
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
    }

    &.ant-select-multiple .ant-select-selection-search-input,
    &.ant-select-multiple .ant-select-selection-search-mirror {
        font-family: ${({ theme }) => theme.font.regular};
    }
`;

export default Select;
